import { useApplicationConfig } from '@bonusly/application';

import { buildURL } from '../util/url';

export const useRecognizeURL = (...paths: (string | number)[]) => {
	const base = useApplicationConfig('recognizeOrigin');
	return buildURL(base)(...paths);
};
